import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stepper: 0,
  couseType: "",
  modal: { flag: false, message: "", error: false },
  arrayItem: [1, 2],
  countryList: [],
  stateList: [],
  cityList: [],
  collegeList: [],
  courseList: [],
  userData: {},
  eventData: {},
  taxList: [],
  categoryList: [],
};

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    increment: (state) => {
      state.stepper += 1;
    },
    decrement: (state) => {
      state.stepper -= 1;
    },
    setStepper: (state, action) => {
      state.stepper = action.payload;
    },
    courseTypeReducer: (state, action) => {
      state.couseType = action.payload;
    },
    arrayItemReducer: (state, action) => ({
      ...state,
      arrayItem: [...state.arrayItem, ...action.payload],
    }),
    countryListReducer: (state, action) => {
      state.countryList = action.payload;
    },
    stateListReducer: (state, action) => {
      state.stateList = action.payload;
    },
    cityListReducer: (state, action) => {
      state.cityList = action.payload;
    },
    collegeListReducer: (state, action) => {
      state.collegeList = action.payload;
    },
    courseListReducer: (state, action) => {
      state.courseList = action.payload;
    },
    showModal: (state, action) => {
      state.modal = {
        flag: true,
        message: action.payload.msg,
        error: action.payload.error,
      };
    },
    hideModal: (state, action) => {
      state.modal = {
        flag: false,
        message: action.payload.msg,
        error: action.payload.error,
      };
    },
    reset: () => initialState,
    userDataReducer: (state) => {
      return { state };
    },

    eventDataReducer: (state, action) => ({
      ...state,
      eventData: { ...action.payload },
    }),

    taxListReducer: (state, action) => (state.taxList = action.payload),

    categoryListReducer: (state, action) => {
      state.categoryList = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  increment,
  decrement,
  arrayItemReducer,
  countryListReducer,
  stateListReducer,
  cityListReducer,
  collegeListReducer,
  courseListReducer,
  courseTypeReducer,
  reset,
  setStepper,
  showModal,
  hideModal,
  userDataReducer,
  eventDataReducer,
  taxListReducer,
  categoryListReducer,
} = counterSlice.actions;

export default counterSlice.reducer;
